import React from "react";
import { Form } from "antd";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

const UserPhone = (props) => {
  // -------------------------- VAR --------------------------

  const { disabled } = props;
  const countries = ["NZ", "VN"];

  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="phone"
      label="Telephone"
      rules={[
        {
          required: true,
          message: "Please input phone number",
        },
        {
          min: 11,
          message: "Invalid Phone",
        },
        {
          max: 15,
          message: "Invalid Phone",
        },
      ]}
    >
      <PhoneInput
        placeholder="Telephone"
        name="phone"
        // maxLength={15}
        // minLength={11}
        disabled={disabled}
        style={{
          opacity: disabled ? 0.5 : 1,
          backgroundColor: disabled ? "#f5f5f5" : "#fff",
        }}
        defaultCountry="NZ"
        international
        countryCallingCodeEditable={false}
        countries={countries}
      />
    </Form.Item>
  );
};

export default UserPhone;
